import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import router from '../router/index'
const io =  require('socket.io-client')

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    message: "",
    event: {
      name: "",
      chatStatus: { status: "open" },
      comments: <any>[],
      polls: <any>[],
      layout: {},
      text: {}
    },
    polls: <any>[],
    user: <any>{},
    socket: {},
    isDashboard: false,
    streamLatency: 22,
    streamTime: null,
    chatCounter: 0,
    hasActiveVote: false,
    activePollId: "",
    currentUsers: 0,
    currentVotes: 0,
    companiesOnline: 0,
    unionsOnline: 0,
    userCount: 0,
    usersWithVotesCount: 0,
    cutVotesCount: 0,
    cutUsers: []
  },
  mutations: {
    changeMessage(state, msg) {
      state.message = msg
    },
    setUserInfo(state, info) {
      if(info.event && !info.event.layout) info.event.layout = {};
      if(info.event) state.event = info.event;
      state.user = info.user;
    },
    setEvent(state, event) {
      if(!event) return;

      if(!event.layout) event.layout = {};
      state.event = event;
    },
    setAdmin(state, bool) {
      state.isDashboard = bool;
    },
    updateEvent(state:any, data:any) {
      state.event[data.name] = data.value;
    },
    viewerCount(state, count) {
      state.currentUsers = count;
    },
    usersWithVotesCount(state, count) {
      state.usersWithVotesCount = count;
    },
    voteCount(state, count) {
      state.currentVotes = count;
    },
    userCount(state, count) {
      state.userCount = count;
    },
    cutVotesCount(state, count) {
      state.cutVotesCount = count;
    },

    setCutUsers(state, users) {
      console.log(users)
      state.cutUsers = users
    },

    companyCount(state, count) {
      state.companiesOnline = count.company_count;
      state.unionsOnline = count.union_count;
    },
    pushComment(state, comment: any) {
      if(!state.event.comments) state.event.comments = [];
      const comments = state.event.comments.slice();
      if(comments.length && comments[comments.length - 1].id === comment.id) return;
      comments.push(comment);
      state.event.comments = comments;
    },
    deleteComment(state, id) {
      let i = state.event.comments.findIndex((com:any) => com.id === id);
      if(i !== -1) state.event.comments.splice(i, 1);
    },
    updateVotingStatus(state, status) {
      state.hasActiveVote = status;
    },
    pollAnswered(state, pollId) {
      if(!state.user.pollsAnswered) state.user.pollsAnswered = []
      state.user.pollsAnswered.push(pollId);
      state.hasActiveVote = false;
    },
    processVote(state, answer) {
      if(state.isDashboard) {
        let polls = state.polls.slice();
        const poll = polls.find((poll:any) => poll._id === answer.pollId);

        if (!poll.answers) poll.answers = []
        poll.answers.push(answer)

        state.polls = polls;
      }
    },

    // Polls

    setPolls (state, polls) {
      state.polls = polls
    },

    newPoll(state, poll) {
      if(!state.polls) state.polls = [];
      state.polls.push(poll);
    },

    updatePoll(state, poll) {
      const polls = state.polls.slice()
      const i = state.polls.findIndex((p:any) => p._id === poll._id);

      state.hasActiveVote = false

      if(poll.status === 'active') { 
        state.activePollId = poll._id;
        state.hasActiveVote = true; 
      }

      if(i === -1) polls.push(poll);
      else polls[i] = poll;
      
      state.polls = polls;
    },

    deletePoll(state, id) {
      let i = state.polls.findIndex((poll:any) => poll._id === id);
      state.polls.splice(i, 1);
    },

    updateLatency(state, latency) {
      state.streamLatency = latency
    },
    updateStreamTime(state, time) {
      state.streamTime = time;
    },
    updateChatCounter(state, sec) {
      state.chatCounter = sec;
    },
    initSocket(state, socket) {
      state.socket = socket;
    }
  },
  actions: {
    API_CALL ({}, call) {
      let query = Axios({
        method: call.method,
        url: process.env.VUE_APP_API_URL + call.url,
        data: call.data,
        headers: Object.assign({ 'x-access-token': localStorage.adminToken }, call.headers),
        params: call.params ? { ...call.params } : {}
      }).catch(err => {
        if(err.response.status === 401) { 
          router.push("/login"); 
          return;
        }

        throw err
      })

      return query;
    },
    STREAM_TIME({ commit }, time) {
      commit("updateStreamTime", time);
      const latency = (new Date().getTime() - time) / 1000;
      commit("updateLatency", latency);
    },
    UpdateLatency({commit}, latency) {
      commit('updateLatencyState', latency)
    },
    INIT_SOCKET({ state, commit }, eventId) {
      const socket = io(process.env.VUE_APP_API_URL, {
        reconnection: true,
        reconnectionAttempts: 99999,
        pingTimeout: 1000,
        pingInterval: 1000
      });
      socket.emit("join_event", eventId);
      commit("initSocket", socket);
    } 
  },
})
